export default class {
    _id;
    _createdOn;
    _clientOrderId;
    _isNotified;
    _notifiedOn;
    _isCompleted;
    _completedOn;

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get createdOn() {
        return this._createdOn;
    }

    set createdOn(value) {
        this._createdOn = value;
    }

    get clientOrderId() {
        return this._clientOrderId;
    }

    set clientOrderId(value) {
        this._clientOrderId = value;
    }

    get isNotified() {
        return this._isNotified;
    }

    set isNotified(value) {
        this._isNotified = value;
    }

    get notifiedOn() {
        return this._notifiedOn;
    }

    set notifiedOn(value) {
        this._notifiedOn = value;
    }

    get isCompleted() {
        return this._isCompleted;
    }

    set isCompleted(value) {
        this._isCompleted = value;
    }

    get completedOn() {
        return this._completedOn;
    }

    set completedOn(value) {
        this._completedOn = value;
    }
}
